export enum SelectionType {
	NotSet = 0,
	BlockSelection = 1,
    SeatSelection = 2
}



// WEBPACK FOOTER //
// ./src/app/models/selection-type.enum.ts